export const VIDEO_URLS = {
  DEMO_POST_A_JOB: 'https://storage.googleapis.com/carcareers-cloud-storage-assets/demos/post-a-job-v3.mp4',
  DEMO_REQUEST_RECRUITER_ASSISTANCE: 'https://storage.googleapis.com/carcareers-cloud-storage-assets/demos/request-a-recruiter-v3.mp4',
  DEMO_MANAGE_CANDIDATES: 'https://storage.googleapis.com/carcareers-cloud-storage-assets/demos/manage-candidates-v3.mp4',
};